var map = {
	"./admin.svg": "Cuti",
	"./astra-bookmark.svg": "GXne",
	"./astra-logo.svg": "FLZ4",
	"./automated-process.svg": "C3U6",
	"./bubble.svg": "7k0e",
	"./building.svg": "vjBF",
	"./calendar.svg": "3Nbk",
	"./checkmark.svg": "wotZ",
	"./circle.svg": "DC6F",
	"./clear.svg": "j3iK",
	"./cross.svg": "k9GA",
	"./drop-down-list.svg": "IXhk",
	"./enquiry.svg": "ouEK",
	"./envelope.svg": "m4SL",
	"./greencare.svg": "FcAF",
	"./group.svg": "G8Va",
	"./hide.svg": "7eqN",
	"./keyboard_arrow_sort.svg": "uSGj",
	"./lightbulb.svg": "3Z0C",
	"./location.svg": "CynE",
	"./locked.svg": "o0rf",
	"./log-out.svg": "SABZ",
	"./log.svg": "RFpB",
	"./niraslogo.svg": "3wch",
	"./notification.svg": "5BLa",
	"./paper-plane.svg": "VSIF",
	"./pencil.svg": "QtaU",
	"./phone.svg": "tegb",
	"./reload.svg": "lJZ5",
	"./sewer.svg": "inSd",
	"./supply-type.svg": "ZCeR",
	"./tags.svg": "Dm1C",
	"./template.svg": "l48A",
	"./ui-design.svg": "KOnV",
	"./user.svg": "fP5l",
	"./user_unlock.svg": "643s",
	"./usergroup.svg": "KXge",
	"./water.svg": "7O0Z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5lmF";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ^\.\/.*\.svg$
// module id = 5lmF
// module chunks = 1